"use strict";
var appn;
(function (appn) {
    var ui;
    (function (ui) {
        var formulabuilder;
        (function (formulabuilder) {
            formulabuilder.currentFormula = null;
            formulabuilder.editedFormula = appn.emptyString;
            formulabuilder.lastvalidatedFormula = appn.emptyString;
            formulabuilder.editedLine = appn.emptyString;
            formulabuilder.currentMode = null;
            formulabuilder.fieldsLoad = null;
            formulabuilder.evaluationContextLoad = null;
            formulabuilder.formulaUpdated = null;
            formulabuilder.designerJson = null;
            formulabuilder.controlName = null;
            formulabuilder.$input = null;
            formulabuilder.isFormula = false;
            formulabuilder.structuredTextMode = undefined;
            formulabuilder.requiresDesignerJson = false;
            formulabuilder.screenId = null;
            let $dialog, $heading, $formulaFieldsSelect, $formulaFunctionsSelect;
            function showDialog(sandbox = false) {
                prepare();
                if (!sandbox)
                    $('#formulaDialog').modal('show');
                populate();
                formulabuilder.currentAiConversation = [];
                formulabuilder.currentHistorySignature = null;
                $('#formulaAiMessages').empty();
                $('#formulaAiPanel').data('initialized', false);
                $('#formulaAiPanel').hide();
                $('.ai-toggle-btn').removeClass('active');
            }
            formulabuilder.showDialog = showDialog;
            var prepare = function () {
                if (formulabuilder.editor)
                    return;
                $dialog = $('#formulaDialog');
                $heading = $('#formulaDialog #myModalLabel-formulaDialog');
                $formulaFieldsSelect = $dialog.find('#formulaFields');
                $formulaFunctionsSelect = $dialog.find('#formulaFunctions');
                formulabuilder.editor = appn.codeMirror.applyToTextArea('#formula', window.appn.codeMirror.codeTypes.formulaBuilder);
                $('#formulaBuilderEvaluate').on('click', function () {
                    formulabuilder.evaluateFormula();
                });
                $dialog.find('#formulaBuilderApply').click(function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                    if (formulabuilder.formulaUpdated)
                        formulabuilder.formulaUpdated(formulabuilder.editor.getValue());
                    formulabuilder.currentFormula = formulabuilder.editor.getValue();
                    formulabuilder.editor.setValue('');
                    setTimeout(function () {
                        formulabuilder.editor.refresh();
                    }, 250);
                    $('#formulaDialog').modal('hide');
                });
                $dialog.find('#formulaBuilderValidate').click(function (event) {
                    formulabuilder.currentFormula = formulabuilder.editor.getValue();
                    formulabuilder.validateFormula(true);
                });
                $dialog.find('#formulaBuilderEvaluate').click(function (event) {
                    formulabuilder.currentFormula = formulabuilder.editor.getValue();
                    formulabuilder.evaluateFormula();
                });
                $dialog.on('hidden.bs.modal', function () {
                    formulabuilder.editor.setValue('');
                    enableElement($('#formulaBuilderValidate'));
                    SetMessageFor($('#validationSuccess'), appn.emptyString, false);
                    SetMessageFor($('#validationError'), appn.emptyString, false);
                    $('#evaluationResult').val('');
                    $('#evaluationResultContainer').hideElement();
                    SetMessageFor($('#formulaInfoCard'), T('When typing, use the TAB key to search and autocomplete formula function names'), true);
                    setTimeout(function () {
                        formulabuilder.editor.refresh();
                    }, 250);
                });
                $dialog.on('fullscreenToggled', function () {
                    setTimeout(function () {
                        formulabuilder.editor.refresh();
                    }, 100);
                });
            };
            formulabuilder.insertIntoFormulaBox = function (selectedVal, replaceAll, enableValidate) {
                if (replaceAll)
                    formulabuilder.editor.setValue("");
                var doc = formulabuilder.editor.getDoc();
                var cursor = doc.getCursor();
                doc.replaceRange(selectedVal, cursor);
                if (enableValidate)
                    enableElement($('#formulaBuilderValidate'));
            };
            formulabuilder.evaluateFormula = function () {
                const resultContainer = $('#evaluationResultContainer');
                const resultBox = $('#evaluationResult');
                const evaluateButton = $('#formulaBuilderEvaluate');
                if (!formulabuilder.currentFormula || formulabuilder.currentFormula.trim().length === 0) {
                    resultBox.val(T('Please enter a formula to evaluate.'));
                    resultContainer.showElement();
                    return;
                }
                disableElement(evaluateButton);
                resultBox.val(T('Evaluating...'));
                resultContainer.showElement();
                const contextJson = formulabuilder.evaluationContextLoad ? formulabuilder.evaluationContextLoad() : null;
                appn.ajax.post({
                    url: appn.urls.root + 'Syncs/Evaluate',
                    data: {
                        formula: formulabuilder.currentFormula,
                        contextJson: contextJson,
                        isFormula: formulabuilder.isFormula
                    },
                    dataType: 'json',
                    done: function (response) {
                        enableElement(evaluateButton);
                        if (response.success) {
                            resultBox.val(response.result);
                        }
                        else {
                            resultBox.val(T('Error: {0}', response.message));
                        }
                    },
                    fail: function () {
                        enableElement(evaluateButton);
                        resultBox.val(T('Evaluation request failed.'));
                    }
                });
            };
            formulabuilder.validateFormula = function (formulaBuilder) {
                var hasLocalError = false;
                if (formulabuilder.$input && !formulaBuilder) {
                    var $inputContainer = formulabuilder.$input.closest('li');
                    hasLocalError = $inputContainer.hasClass('has-error') && !$inputContainer.hasClass('has-error-remote');
                    if (!hasLocalError) {
                        $inputContainer.removeClass('error has-error has-error-remote');
                        $inputContainer.find('.errorList').remove();
                    }
                }
                const check = formulabuilder.requiresDesignerJson
                    ? Boolean(formulabuilder.currentFormula && (formulabuilder.designerJson || formulabuilder.screenId))
                    : Boolean(formulabuilder.currentFormula);
                const successContainer = $('#validationSuccess');
                const errorContainer = $('#validationError');
                const infoContainer = $('#formulaInfoCard');
                const validateButton = $('#formulaBuilderValidate');
                if (!check) {
                    disableElement(validateButton);
                    SetMessageFor(successContainer, appn.emptyString, false);
                    SetMessageFor(errorContainer, 'Could not validate the formula, please save the page to see if the formula is valid', true);
                    $('.CodeMirror').removeClass('error');
                }
                const localIsFormula = formulabuilder.isFormula !== null || formulabuilder.isFormula !== undefined ? formulabuilder.isFormula : true;
                var data = {
                    formula: formulabuilder.currentFormula,
                    controlName: formulabuilder.controlName,
                    designerJson: formulabuilder.designerJson,
                    isFormula: localIsFormula,
                    possibleStructuredTextMode: formulabuilder.structuredTextMode,
                    screenId: formulabuilder.screenId
                };
                appn.ajax.post({
                    url: appn.urls.root + 'Forms/ValidateFormula',
                    data: data,
                    dataType: 'json',
                    done: function (response) {
                        $('.validationWarningMessage').html('');
                        if (response.msgType === 'warning') {
                            if (formulaBuilder) {
                                disableElement(validateButton);
                                SetMessageFor(successContainer, appn.emptyString, false);
                                SetMessageFor(infoContainer, 'When typing, use the TAB key to search and autocomplete formula function names', false);
                                SetMessageFor(errorContainer, response.message, true);
                                $('.CodeMirror').addClass('error');
                                formulabuilder.lastvalidatedFormula = formulabuilder.editedFormula;
                            }
                            else if ($inputContainer && !hasLocalError) {
                                formulabuilder.$input.closest('li').addClass('error has-error has-error-remote');
                                $('<ul/>')
                                    .addClass('errorList list-unstyled')
                                    .append('<li>' + response.message + '</li>')
                                    .appendTo($inputContainer);
                                formulabuilder.$input.closest('.input-group').attr('data-validationstate', 'error');
                            }
                        }
                        else {
                            if (formulaBuilder) {
                                disableElement(validateButton);
                                SetMessageFor(errorContainer, appn.emptyString, false);
                                SetMessageFor(infoContainer, 'When typing, use the TAB key to search and autocomplete formula function names', false);
                                SetMessageFor(successContainer, 'Formula is valid', true);
                                $('.CodeMirror').addClass('valid');
                                formulabuilder.lastvalidatedFormula = formulabuilder.editedFormula;
                            }
                            else if ($inputContainer && !hasLocalError) {
                                $inputContainer.removeClass('error has-error has-error-remote');
                                $inputContainer.find('.errorList').remove();
                                formulabuilder.$input.closest('.input-group').attr('data-validationstate', 'success');
                            }
                            if (window.isSandbox)
                                window.activateCalculateButton();
                        }
                    },
                    fail: function () {
                        if (formulaBuilder) {
                            disableElement(validateButton);
                            SetMessageFor(successContainer, appn.emptyString, false);
                            SetMessageFor(errorContainer, 'Could not validate the formula, please save the page to see if the formula is valid', true);
                            $('.CodeMirror').removeClass('error');
                        }
                    }
                });
            };
            function SetMessageFor(element, message, isVisible) {
                const container = element.find('.card-title');
                const htmlContent = container.html();
                const icon = htmlContent.substring(0, htmlContent.indexOf('</i>') + 4);
                container.html(`${icon}<span class="h6 mb-0">${message}</span>`);
                if (isVisible)
                    element.showElement();
                else
                    element.hideElement();
            }
            var populate = function () {
                var _a, _b;
                if (appn.utils.hasValue(formulabuilder.structuredTextMode))
                    appn.codeMirror.setFormulaBuilderStructuredConfig(formulabuilder.editor);
                formulabuilder.editor.clearHistory();
                formulabuilder.editor.setOption('template', formulabuilder.currentMode === 'template');
                if (formulabuilder.currentFormula) {
                    formulabuilder.editor.setValue(formulabuilder.currentFormula);
                    setTimeout(function () {
                        formulabuilder.editor.refresh();
                    }, 250);
                }
                else {
                    formulabuilder.currentFormula = null;
                    formulabuilder.editor.setValue('');
                    setTimeout(function () {
                        formulabuilder.editor.refresh();
                    }, 250);
                }
                if (formulabuilder.currentMode === "formulaOnly") {
                    $formulaFieldsSelect.closest('div').hideElement();
                }
                else {
                    $formulaFieldsSelect.closest('div').showElement();
                    if ($formulaFieldsSelect.children('option:not(:first)').length === 0 && formulabuilder.fieldsLoad) {
                        $formulaFieldsSelect.children('option:not(:first)').remove();
                        formulabuilder.fieldsLoad($formulaFieldsSelect);
                    }
                    var ignoreInitialSelect = true;
                    $formulaFieldsSelect.children('option:first').attr('selected', 'selected');
                    appn.select.destroy('#formulaFields');
                    $('#formulaFields').off('select2:select');
                    appn.select.init({
                        selector: '#formulaFields',
                        onSelectCallback: function (e) {
                            const data = e.params.data;
                            if (ignoreInitialSelect)
                                return;
                            var selectedVal = data.id;
                            if (selectedVal === '')
                                return;
                            selectedVal = '{{' + selectedVal + '}}';
                            formulabuilder.insertIntoFormulaBox(selectedVal);
                            $formulaFieldsSelect.val(appn.emptyString);
                            $formulaFieldsSelect.trigger('change');
                        }
                    });
                }
                var formulaPropTitle = (_a = formulabuilder.$input === null || formulabuilder.$input === void 0 ? void 0 : formulabuilder.$input.data('field-name')) !== null && _a !== void 0 ? _a : (_b = formulabuilder.$input === null || formulabuilder.$input === void 0 ? void 0 : formulabuilder.$input.attr('id')) === null || _b === void 0 ? void 0 : _b.replace('property_', '');
                var designerCheck = ui.designerAreaCheck();
                var icon = '<i class=\"fa fa-hammer\"></i>';
                var badge = $('<span class="badge badge-info ml-2 font-weight-light"></span>');
                const currentDesignerCheck = ui.designerAreaCheck();
                const evalContextAllowed = formulabuilder.evaluationContextLoad || currentDesignerCheck.isSync;
                if (evalContextAllowed) {
                    $dialog.find('#evaluateButton').showElement();
                    $dialog.find('#validateButton').hideElement();
                }
                else {
                    $dialog.find('#evaluateButton').hideElement();
                    $dialog.find('#validateButton').showElement();
                }
                if (formulabuilder.currentMode === 'fieldsOnly' ||
                    formulabuilder.currentMode === 'uitext') {
                    $dialog.find('#formulaFunctions').hideElement();
                    $dialog.find('.formulaFields-right-dropdown').hideElement();
                    if (designerCheck.type === appn.ScreenType.form)
                        $heading.html(`${icon}Text Builder${(badge.text(`Field: ${formulabuilder.controlName}`)).prop('outerHTML')}${(badge.text(formulaPropTitle === undefined ? appn.emptyString : `Property: ${formulaPropTitle}`)).prop('outerHTML')}`);
                    else
                        $heading.html(`${icon}Text Builder`);
                    appn.select.destroy('#formulaFunctions');
                    $('#formulaFunctions').off('select2:select');
                    appn.select.init({
                        selector: '#formulaFunctions'
                    });
                }
                else {
                    var designerJsonObj = JSON.parse(formulabuilder.designerJson);
                    if (formulabuilder.currentMode === 'template') {
                        if (designerCheck.type === appn.ScreenType.form)
                            $heading.html(`${icon}Text Builder${(badge.text(formulabuilder.controlName === undefined ? `Screen: ${designerJsonObj.title}` : `Field: ${formulabuilder.controlName}`)).prop('outerHTML')}${(badge.text(formulaPropTitle === undefined ? appn.emptyString : `Property: ${formulaPropTitle}`)).prop('outerHTML')}`);
                        else
                            $heading.html(`${icon}Text Builder`);
                    }
                    else {
                        if (designerCheck.type === appn.ScreenType.form)
                            $heading.html(`${icon}Formula Builder${(badge.text(formulabuilder.controlName === undefined ? `Screen: ${designerJsonObj.title}` : `Field: ${formulabuilder.controlName}`)).prop('outerHTML')}${(badge.text(formulaPropTitle === undefined ? appn.emptyString : `Property: ${formulaPropTitle}`)).prop('outerHTML')}`);
                        else
                            $heading.html(`${icon}Formula Builder`);
                        formulabuilder.isFormula = true;
                    }
                    $dialog.find('#formulaFunctions').showElement();
                    $dialog.find('.formulaFields-right-dropdown').showElement();
                    $formulaFunctionsSelect.children('option:first').attr('selected', 'selected');
                    appn.select.destroy('#formulaFunctions');
                    $('#formulaFunctions').off('select2:select');
                    appn.select.init({
                        selector: '#formulaFunctions',
                        onSelectCallback: function (e) {
                            const data = e.params.data;
                            if (ignoreInitialSelect)
                                return;
                            var selectedVal = data.id;
                            if (selectedVal === '')
                                return;
                            if (formulabuilder.currentMode === 'template')
                                selectedVal = '{( ' + selectedVal + ' )}';
                            formulabuilder.insertIntoFormulaBox(selectedVal);
                            $formulaFunctionsSelect.val(appn.emptyString);
                            $formulaFunctionsSelect.trigger('change');
                        }
                    });
                }
                ignoreInitialSelect = false;
                setTimeout(function () {
                    formulabuilder.editor.refresh();
                    formulabuilder.editor.focus();
                }, 150);
                var targetNode = $('.CodeMirror .CodeMirror-code');
                var mutationObserver = window.MutationObserver;
                var observer = new mutationObserver(mutationHandler);
                var obsConfig = {
                    childList: true,
                    characterData: true,
                    attributes: true,
                    subtree: true,
                    attributeOldValue: true,
                    characterDataOldValue: true
                };
                targetNode.each(function () {
                    observer.observe(this, obsConfig);
                });
                var designerCheck = ui.designerAreaCheck();
                if (designerCheck.isDesigner && designerCheck.type === appn.ScreenType.form)
                    prepareCommentHeader();
            };
            function mutationHandler(mutationList, observer) {
                $('.CodeMirror').removeClass('error');
                $('.CodeMirror').removeClass('valid');
                const mutations = mutationList.filter((o, i, a) => {
                    var _a, _b, _c;
                    return (((_a = $(o.target).attr('class')) === null || _a === void 0 ? void 0 : _a.indexOf('CodeMirror-cursors')) === -1 &&
                        ((_b = $(o.target).attr('class')) === null || _b === void 0 ? void 0 : _b.indexOf('CodeMirror-measure')) === -1 &&
                        ((_c = $(o.target).attr('class')) === null || _c === void 0 ? void 0 : _c.indexOf('CodeMirror-code')) === -1);
                });
                const validateButton = $('#formulaBuilderValidate');
                formulabuilder.editedFormula = formulabuilder.editor.getValue();
                if (mutations.length === 0) {
                    observer.takeRecords();
                    if (formulabuilder.editedFormula.trim().length === 0)
                        disableElement(validateButton);
                    return;
                }
                const lineText = mutations[0].target.innerText;
                if (formulabuilder.editedLine !== appn.emptyString) {
                    if (formulabuilder.editedLine === lineText)
                        return;
                }
                formulabuilder.editedLine = lineText;
                const check = formulabuilder.requiresDesignerJson ? Boolean(formulabuilder.designerJson || formulabuilder.screenId) : true;
                if (check
                    && formulabuilder.editedFormula.trim().length > 0
                    && formulabuilder.editedFormula.trim() !== formulabuilder.lastvalidatedFormula
                    && (formulabuilder.currentFormula !== formulabuilder.editedFormula.trim() || formulabuilder.currentFormula !== formulabuilder.lastvalidatedFormula.trim())) {
                    enableElement(validateButton);
                    formulabuilder.currentFormula = formulabuilder.editedFormula;
                }
                else
                    disableElement(validateButton);
                SetMessageFor($('#formulaInfoCard'), 'When typing, use the TAB key to search and autocomplete formula function names', true);
                SetMessageFor($('#validationError'), appn.emptyString, false);
                SetMessageFor($('#validationSuccess'), appn.emptyString, false);
            }
            function enableElement(element) {
                const classesString = element.attr('class');
                const classes = classesString.split(' ').filter((o, i, a) => { return o.length > 0 && o.indexOf('disabled') === -1; });
                element.attr('class', classes.join(' '));
            }
            function disableElement(element) {
                const classesString = element.attr('class');
                const classes = classesString.split(' ').filter((o, i, a) => { return o.length > 0; });
                classes.push('disabled');
                element.attr('class', classes.join(' '));
            }
            function prepareCommentHeader() {
                const dialogHeader = $('#myModalLabel-formulaDialog').text();
                const headerRow = $('.formula-dialog-increased-height .card-body .builder-controls');
                const commentContainer = headerRow.find('#commentButton');
                if (dialogHeader.includes('Formula')) {
                    setCommentControls(commentContainer);
                    return;
                }
                resetCommentControls(commentContainer);
            }
            function setCommentControls(comment) {
                if (!comment.hasClass('d-none'))
                    return;
                comment.removeClass('d-none');
                addCommentEvents();
            }
            function resetCommentControls(comment) {
                if (comment.hasClass('d-none'))
                    return;
                comment.addClass('d-none');
                removeCommentEvents();
            }
            function addCommentEvents() {
                $('#commentButton').off().on('click', function () {
                    if (formulabuilder.editor.somethingSelected()) {
                        var selectionFrom = formulabuilder.editor.getCursor('from');
                        var selectionTo = formulabuilder.editor.getCursor('to');
                        var from = { line: selectionFrom.line, ch: selectionFrom.ch };
                        var to = { line: selectionTo.line, ch: selectionTo.ch };
                        var firstLineText = formulabuilder.editor.getLine(from.line);
                        if (firstLineText.indexOf('/*') > -1) {
                            formulabuilder.editor.uncomment(from, to);
                            return;
                        }
                        formulabuilder.editor.blockComment(from, to);
                    }
                    else {
                        var cursor = formulabuilder.editor.getCursor();
                        formulabuilder.editor.setSelection(cursor);
                        formulabuilder.editor.replaceSelection('/* Add comments here */');
                    }
                });
            }
            function removeCommentEvents() {
                $('#commentButton').off();
            }
            formulabuilder.aiAssistantUrl = null;
            formulabuilder.currentAiConversation = [];
            formulabuilder.currentHistorySignature = null;
            formulabuilder.formulaMode = '';
            function initAi(url, mode) {
                formulabuilder.aiAssistantUrl = url;
                formulabuilder.formulaMode = mode || '';
                $('.ai-toggle-btn').show();
                const helloMessageTemplate = T(`Hi there! Need some help with building your formula? Simply tell me what you need!`);
                $('.ai-toggle-btn').off('click').on('click', function (e) {
                    e.preventDefault();
                    const $panel = $('#formulaAiPanel');
                    const $messages = $('#formulaAiMessages');
                    $(this).tooltip('hide');
                    if (!$panel.data('initialized')) {
                        const sender = '<span class="text-purple"><i class="fas fa-sparkles"></i> AI</span>';
                        const helloHtml = `
                    <div class="ai-message-wrapper text-left mb-2">
                        <div class="ai-message d-inline-block p-2 rounded" style="max-width: 60%; text-align: left;">
                            <div class="small font-weight-bold mb-1">${sender}</div>
                            <div class="ai-message-content small text-dark">${helloMessageTemplate}</div>
                        </div>
                    </div>
                `;
                        $messages.html(helloHtml);
                        $panel.data('initialized', true);
                    }
                    $panel.slideToggle();
                    $(this).toggleClass('active');
                });
                $('#formulaAiSend').off('click').on('click', function (e) {
                    e.preventDefault();
                    sendAiPrompt();
                });
                $('#formulaAiInput').off('keypress').on('keypress', function (e) {
                    if (e.which === 13 && !e.shiftKey) {
                        e.preventDefault();
                        sendAiPrompt();
                    }
                });
                appn.infer.hookSpeechToText($('#formulaAiPanel .prompt-speech'), $('#formulaAiInput'));
                appn.infer.setupAutoInputGrow($('#formulaAiInput'));
            }
            formulabuilder.initAi = initAi;
            function sendAiPrompt() {
                const $input = $('#formulaAiInput');
                const prompt = $input.val();
                if (!prompt || prompt.trim().length < 10) {
                    appn.toast.notify(appn.toast.Type.error, T('A minimum of 10 characters is required for AI assistance.'));
                    return;
                }
                const $messages = $('#formulaAiMessages');
                const $sendBtn = $('#formulaAiSend');
                addAiMessage('user', prompt);
                $input.val('').trigger('input');
                const $loading = $(`<div class="ai-loading mb-2 small text-muted"><i class="fas fa-sparkles fa-spin mr-1"></i> ${T('Thinking...')}</div>`);
                $messages.append($loading);
                $messages.scrollTop($messages.prop('scrollHeight'));
                $sendBtn.prop('disabled', true);
                const fields = [];
                $formulaFieldsSelect.find('option:not(:first)').each((_, opt) => {
                    fields.push({ value: $(opt).val(), text: $(opt).text() });
                });
                const contextJson = formulabuilder.evaluationContextLoad ? formulabuilder.evaluationContextLoad() : null;
                appn.ajax.post({
                    url: formulabuilder.aiAssistantUrl || '',
                    dataType: 'json',
                    data: {
                        prompt: prompt,
                        conversationJson: JSON.stringify(formulabuilder.currentAiConversation),
                        mode: formulabuilder.formulaMode,
                        currentFormula: formulabuilder.editor.getValue(),
                        fieldsJson: JSON.stringify(fields),
                        contextJson: contextJson ? JSON.stringify(contextJson) : null,
                        historySignature: formulabuilder.currentHistorySignature
                    },
                    done: function (data) {
                        const responseObj = typeof data === 'string' ? JSON.parse(data) : data;
                        $loading.remove();
                        if (responseObj.success && responseObj.response) {
                            formulabuilder.currentHistorySignature = responseObj.historySignature;
                            const response = responseObj.response;
                            let messageContent = '';
                            if (response.formulaCode) {
                                const safeFormula = response.formulaCode
                                    .replace(/&/g, "&amp;")
                                    .replace(/</g, "&lt;")
                                    .replace(/>/g, "&gt;")
                                    .replace(/\n/g, "<br>");
                                messageContent += `<pre class="mb-2 p-2 bg-dark text-light rounded small" style="font-family: monospace;">${safeFormula}</pre>`;
                            }
                            const safeExplanation = response.explanation
                                .replace(/&/g, "&amp;")
                                .replace(/</g, "&lt;")
                                .replace(/>/g, "&gt;")
                                .replace(/\n/g, "<br>");
                            messageContent += `<div class="ai-message-content">${safeExplanation}</div>`;
                            const aiMsg = addAiMessage('model', '');
                            aiMsg.find('.ai-message-content').html(messageContent);
                            if (response.formulaCode) {
                                const $applyBtn = $(`<button class="btn btn-xs btn-outline-purple mt-2">${T('Apply Formula')}</button>`);
                                $applyBtn.on('click', function () {
                                    formulabuilder.editor.setValue(response.formulaCode);
                                    formulabuilder.lastvalidatedFormula = '';
                                    enableElement($('#formulaBuilderValidate'));
                                });
                                aiMsg.find('.ai-message').append($applyBtn);
                            }
                            formulabuilder.currentAiConversation.push(...responseObj.turns);
                        }
                        else if (responseObj.ErrorType === "usage_limit_exceeded") {
                            addAiMessage('model', `${responseObj.Message}. ${T('Please upgrade your plan.')}`);
                        }
                        else {
                            addAiMessage('model', responseObj.Message || T('Failed to get a response from AI.'));
                        }
                    },
                    fail: function () {
                        $loading.remove();
                        addAiMessage('model', T('Failed to communicate with the server.'));
                    },
                    always: function () {
                        $sendBtn.prop('disabled', false);
                    }
                });
            }
            function addAiMessage(role, text) {
                const $messages = $('#formulaAiMessages');
                const sender = role === 'user' ? T('You') : '<span class="text-purple"><i class="fas fa-sparkles"></i> AI</span>';
                const alignment = role === 'user' ? 'text-right' : 'text-left';
                const safeText = text.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\n/g, "<br>");
                const html = `
            <div class="ai-message-wrapper ${alignment} mb-2">
                <div class="ai-message d-inline-block p-2 rounded" style="max-width: 60%; text-align: left;">
                    <div class="small font-weight-bold mb-1">${sender}</div>
                    <div class="ai-message-content small text-dark">${safeText}</div>
                </div>
            </div>`;
                const $msg = $(html);
                $messages.append($msg);
                $messages.scrollTop($messages.prop('scrollHeight'));
                return $msg;
            }
        })(formulabuilder = ui.formulabuilder || (ui.formulabuilder = {}));
    })(ui = appn.ui || (appn.ui = {}));
})(appn || (appn = {}));
